{
  "nav": {
    "home": "Home",
    "services": "Services",
    "prices": "Prices",
    "projects": "Projects",
    "about": "About",
    "contact": "Contact",
    "email": "Email",
    "linkedin": "LinkedIn"
  },
  "backToProjects": "Back to projects",
  "projectOverview": "Project overview",
  "overview": "Overview",
  "challenge": "The challenge",
  "businessNeed": "The business need",
  "philosophy": "The philosophy",
  "goal": "The goal",
  "solution": "The solution",
  "polestarLandingPage": "Polestar Live landing page"
}
